// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ModeType } from 'src/app/enums/mode-type.enum';
import { RegionType } from 'src/app/enums/region-type.enum';

export const environment = {
  configurationData: [],
  production: true,
  mode: ModeType.Prod2,
  Aus: {
    userPoolId: 'ap-southeast-2_qLZRRb7Ko',
    region: 'ap-southeast-2',
    regionName: 'Australia',
    appClients: [
      {
        id: 'NWRtMzd2MXY1djU4OGRybDZyNG1vaG5vY2Y=',
        urlOmni: 'https://au.identity.cbord.com',
        urlTLMiddleware: 'https://api.au.traylogistics2.cbord.com',
      },
    ],
  },
  US: {
    userPoolId: 'us-east-1_afct0WxYR',
    region: RegionType.USA,
    regionName: 'United States of America',
    clientId: '38fcj07hsd225g1tvacanmiq6g',
    appClients: [
      {
        id: 'MzhmY2owN2hzZDIyNWcxdHZhY2FubWlxNmc=',
        urlOmni: 'https://identity.api.cbord.com',
        urlTLMiddleware: 'https://api.traylogistics2.cbord.com',
      },
    ],
  },
  accessKeyId: '',
  secretAccessKey: '',
  parameterSSM: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
